import { createApiInstance } from "./Api";

const createUserService = () => {

  const Api = createApiInstance();

  return {
    getStoresActionsStats: async () =>
      Api.get('users/store-actions-stats'),
    getStoresActionsChartStats: async () =>
      Api.get('users/store-actions-stats-chart'),
    getStoresOfUsers: async () =>
      Api.get('users/stores'),
    postTicket: async (data: any) =>
      Api.post('users/ticket', data),
  };
};

export default createUserService;
